$(document).ready(function(){
  $("#btn-scroll").click(function(event){ 
    event.preventDefault();
    var sectionOffset = $(".dtc-scroll").offset().top + $(".dtc-scroll").outerHeight();
    $("html, body").animate({ scrollTop: sectionOffset }, "slow");
  });
});

$(document).ready(function(){
  $("#btn-scroll-2").click(function(event){ 
    event.preventDefault();
    var sectionOffset = $(".dtc-scroll").offset().top + $(".dtc-scroll").outerHeight();
    $("html, body").animate({ scrollTop: sectionOffset }, "slow");
  });
});